module.exports = {
    palette: {
      primary: { main: '#2196f3' },
      secondary: { main: '#f50057' },
          
    },
    progress: {
      postion: 'absolute',
      marginLeft: 8
        
    },
  
    // change body1 to body2
    // https://github.com/mui-org/material-ui/issues/13175
    typography: {
      useNextVariants: true,
    },
    
  };